module.exports = __webpack_public_path__ + "img/block_04_img.1b81b7a9.png";